import React from 'react'
import useAuthenticationStore, { AuthenticationViews } from './Store';
import { useConfiguration } from './Configuration';
import Join from './Join';

const JoinContainer: React.FC = () => {
  const { state, dispatch, startJoin } = useAuthenticationStore()
  const { emailOrPhone, isLoading, clientErrors, serverError } = state
  const { configuration } = useConfiguration()

  const setEmailOrPhone = (newEmailOrPhone: string) => {
    dispatch({ type: 'SET_EMAIL_OR_PHONE', payload: newEmailOrPhone })
  }

  return (
    <Join
      emailOrPhone={emailOrPhone}
      isLoading={isLoading}
      clientErrors={clientErrors}
      serverError={serverError}
      externalLoginLinks={configuration.externalLoginLinks}
      loginLink={"../" + AuthenticationViews.login}
      startJoin={startJoin}
      setEmailOrPhone={setEmailOrPhone}
    />
  )
}

export default JoinContainer